import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActionState } from 'src/app/enums/action-state.enum';
import { CoreEnum } from 'src/app/enums/core.enum';
import { SubscriptionRepo } from 'src/app/repositories/subscription-repo';
import { EnergyType, Subscription } from 'src/swagger-gen/web-secured/models';


@Component({
    selector: 'app-modal-subscription-info',
    templateUrl: './modal-subscription-info.component.html',
    styleUrls: ['./modal-subscription-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalSubscriptionInfoComponent implements OnInit, OnDestroy {
  destroyed$ = new Subject<void>();
  loadingState = new BehaviorSubject('');
  actionState = ActionState;
  loading: boolean;
  error: any;
  subscription: Subscription;
  energyList = Object.values(EnergyType);
  selectedEnergies: EnergyType[] = [];
  validityStartDisplayDate: string;
  validityEndDisplayDate: string;

  USER_SUBSCRIPTION = CoreEnum.USER_SUBSCRIPTION;

  readonly na = 'N/A';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private subscriptionRepo: SubscriptionRepo
  ) {}

  ngOnInit(): void {
    this.getSubscription(this.data.uid);
  }

  getSubscription(uid: string) {
    this.loadingState.next(ActionState.LOADING);
    this.subscriptionRepo
      .getSubscription(uid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res: Subscription) => {
          
          this.error = false;
          this.subscription = this.formatSubscriptionValue(res);
          this.convertStationEnergies(res.energies);
          this.loadingState.next(ActionState.READY);
        },
        error: (error) => {
          this.loadingState.next(ActionState.FAILED);
          this.error = error.error;
        },
      });
  }

  convertStationEnergies(energies: EnergyType[]) {
    if (energies?.length > 0) {
      energies.forEach((e) => { this.selectedEnergies.push(e)});
    }
  }

  formatSubscriptionValue(subscription: Subscription): Subscription {
    return Object.assign(subscription, { name: subscription.name || this.na });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
